// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".controller-area[data-v-25492535]{position:absolute;bottom:9%;right:5px}.outer[data-v-25492535]{width:inherit;height:inherit}.maincam-view[data-v-25492535]{position:relative;width:100%;height:100%;background-color:#000}", ""]);
// Exports
module.exports = exports;
